import moment from 'moment';
import { NavLink, PT, React, WithData, withRouter } from '@gasbuddy/react';
import { Dimmer, Divider, Loader, Segment, Table } from 'semantic-ui-react';
import { Auth, Nav } from '../../components';
import { TransactionAuthTools } from '../../devtools/TransactionAuthTools';
import { Role } from '../../roles';

const CDNP = 'cdnp';
const addr = address => (
  <div>
    <div>{address.line_1}</div>
    <div>
      {address.locality}
      ,
      {' '}
      {address.region}
      {' '}
      {address.postal_code}
    </div>
  </div>
);
class TxAuthDetail extends React.Component {
  state = { loading: false }

  render() {
    const { data, loading, fetch: fetchFn, history } = this.props;
    const { loading: stateLoading } = this.state;
    const locationInfo = (
      <div>
        <b>{data.merchant && data.merchant.merchant_name}</b>
        <br />
        {data.merchant && data.merchant.address && addr(data.merchant.address)}
      </div>
    );
    return (
      <Segment>
        <Dimmer active={loading || stateLoading}>
          <Loader />
        </Dimmer>

        <div>
          <h1>
            Transaction Auth #
            <span>{data.transaction_auth_id}</span>
          </h1>
          <div>
            <b>Account:</b>
            <NavLink to={`/identity/users/${data.account_id}`}>
              {data.account_id}
            </NavLink>
          </div>
          <b>{data.created_at && moment(data.created_at).format('MMM DD, YYYY hh:mm:ss a ZZ')}</b>
        </div>
        <Divider />
        {locationInfo}
        <h3>Details</h3>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="center" width={2}>AuthTime</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Amount</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">AuthCode</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">AuthStatus</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">AuthNetwork</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">AuthPurchasePoint</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">ExternalAuthID</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">ExtraData</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>{data.auth_time ? moment(data.auth_time).toISOString(true) : undefined}</Table.Cell>
              <Table.Cell>
                {data.amount ? `$${Number(data.amount).toFixed(2)}` : undefined}
              </Table.Cell>
              <Table.Cell>{data.auth_code}</Table.Cell>
              <Table.Cell>{data.auth_status}</Table.Cell>
              <Table.Cell>{data.auth_network}</Table.Cell>
              <Table.Cell>{data.auth_purchase_point}</Table.Cell>
              <Table.Cell>{data.external_auth_id}</Table.Cell>
              <Table.Cell>{JSON.stringify(data.extra_data || {})}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        {process.env.NODE_ENV !== 'production'
          && data.auth_network !== CDNP
          && <TransactionAuthTools transactionAuth={data} onChange={fetchFn} history={history} />
        }
      </Segment>
    );
  }
}

TxAuthDetail.propTypes = {
  data: PT.shape({
    account_id: PT.number,
    amount: PT.string,
    auth_code: PT.string,
    auth_status: PT.string,
    auth_time: PT.string,
    auth_purchase_point: PT.string,
    created_at: PT.string,
    external_auth_id: PT.string,
    instrument_account_map_id: PT.number,
    instrument_id: PT.number,
    transaction_auth_id: PT.number,
    merchant: PT.shape({
      merchant_id: PT.number,
      merchant_name: PT.string,
      internal_name: PT.string,
      address: PT.shape({
        line_1: PT.string,
        locality: PT.string,
        region: PT.string,
        postal_code: PT.string,
      }),
    }),
    transaction_id: PT.number,
    extra_data: PT.object,
  }),
  loading: PT.bool,
  fetch: PT.func,
  history: PT.shape({ push: PT.func }).isRequired,
};

TxAuthDetail.defaultProps = {
  data: {},
  loading: false,
  fetch: () => {},
};

const dataUrl = ({ account, id }) => `/payments/transaction-auth/${account}/${id}`;

export const TransactionAuth = withRouter(({ match, history }) => (
  <Auth forRoles={[Role.Superuser, Role.PaymentView]}>
    <Nav>
      <WithData url={dataUrl(match.params)}>
        <TxAuthDetail history={history} />
      </WithData>
    </Nav>
  </Auth>
));
